import React, { FunctionComponent } from 'react'
interface Prop {
  token?: string
}
const TouchScreenLayout: FunctionComponent<React.PropsWithChildren<Prop>> = (props) => {
  return (
    <div className='pb-24 bg-mainbg'>
      {props.children}
    </div>

  )
}

export default TouchScreenLayout
